/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WarningSmall1(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WarningSmall1',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 15 * scale,
      viewBox: '0 0 18 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M16.256 12.698 9.744 1.302c-.41-.716-1.08-.716-1.488 0L1.744 12.698c-.41.716-.07 1.302.756 1.302h13c.825 0 1.165-.586.756-1.302M9 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m.618-3H8.382L8 5h2z"}))
}
